module.exports = __webpack_public_path__ + "img/logo.3f5c263a.svg";